/**
 * Gets a unique identifier.
 * @returns {string} UUID
 */
export function uuid() {
    const alpha = '0123456789abcdefghjkmnpqrstvwxyz'
    const buf = randomBytes(16)
    return regroupBits(buf, 5).map(i => alpha[i]).join('')
}

function regroupBits(buf: any, nbits: any) {
    let count = 0
    let total = 0
    const result = []
    let index = 0
    for(; ;) {
        if(count >= nbits) {
            // We have enough bits to be able to add to the result
            count -= nbits
            result.push(total >> count)
            total &= (1 << count) - 1
        } else if(index < buf.length) {
            // Grab the next 8 bits from the array element
            count += 8
            total <<= 8
            total += buf[index]
            ++index
        } else {
            // There might be some leftover bits, but we're just going to discard them!
            // if (count) result.push(total << nbits - count);
            return result
        }
    }
}

/**
 * Generate an array of random bytes. Uses `crypto.getRandomValues` if available, otherwise falls back to `Math.random`
 * (insecure)
 *
 * @param {number} howMany How many "bytes" (uint8s) to generate
 * @returns {Uint8Array|number[]} Array of ints [0-255]
 */
function randomBytes(howMany: any) {
    if(globalThis.Uint8Array && globalThis.crypto && globalThis.crypto.getRandomValues) {
        const buf = new Uint8Array(howMany)
        crypto.getRandomValues(buf)
        return buf
    } else {
        const buf = new Array(howMany)
        for(let i = 0; i < buf.length; ++i) {
            buf[i] = Math.floor(Math.random() * 256)
        }
        return buf
    }
}

export function randomFloat(min: number, max: number): number {
    if(min > max) {
        throw new Error('The min value must be less than the max value')
    }
    return Math.random() * (max - min) + min
}
